import { EmoticonCryOutlineIcon } from './EmoticonCryOutlineIcon';

/**
 * author: Michael Irigoyen
 * id BA4B161E-72CB-476B-9894-20A90B28B4A3
 * name emoticon-cry-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-cry-outline.svg
 * tags
 * - Emoji 
 */
export const EmojiCryOutlineIcon = EmoticonCryOutlineIcon;
export default EmojiCryOutlineIcon